import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { K as m, d as v } from "./input-format-040de3c9-ea425185.js";
import { Ge as g, hi as $, bo as f, w as u, di as y, M as s } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as T } from "./state-b4c9cc73-ee633f6c.js";
import { i as P } from "./query-24926cff-3eb94bfb.js";
import { p as a } from "./if-defined-51ce653c-cfb10574.js";
import { m as b } from "./live-2103029c-4cfa6430.js";
import { h as S, s as N } from "./form-base-01fb45f3-a50e84ff.js";
import { e as h } from "./icon-position-716424dc-4651e2c2.js";
import "./form-associated-d3ceba31-80e8a7c4.js";
import "./utils-2e24a437-383bbd0f.js";
import "./directive-daf4e9b6-abc0af54.js";
import "./directive-helpers-336ae7bb-f6343f09.js";
var o = {
    beaconTagName: "beacon-input-field",
    formatProp: "format",
    formatTypeAttr: "format-type",
    formatTypeProp: "formatType",
    iconUrlProp: "icon-url",
    iconPositionProp: "icon-position",
    iconCSSVar: "--input-field-icon",
    beaconNestedComponents: ["beacon-error"],
    beaconErrorTagName: "beacon-error",
    HINT_ID: "hint",
    ERROR_ID: "error"
  },
  R = g(_templateObject || (_templateObject = _taggedTemplateLiteral(["label,.label{font-size:var(--beacon-form-label-font-size);font-weight:var(--beacon-form-label-font-weight);line-height:var(--beacon-form-label-font-line-height);margin:0;padding:0}.hint{font-size:var(--beacon-form-font-size);line-height:var(--beacon-form-font-line-height);margin:0}input,select,textarea{color:var(--beacon-form-field-color-text-default)}[aria-disabled=true]{caret-color:transparent;color:var(--beacon-form-field-color-text-inactive);cursor:not-allowed}input{--border-color: var(--beacon-form-field-color-border-default);--border-size: var(--beacon-form-field-size-border-width-default);--font-color: var(--beacon-form-field-color-text-default);background-color:var(--beacon-form-field-color-background);block-size:var(--beacon-form-field-size-block);border:var(--border-size) solid var(--border-color);border-radius:var(--beacon-form-field-size-border-radius);color:var(--font-color);font-size:var(--beacon-form-font-size);inline-size:100%;line-height:var(--beacon-form-font-line-height);margin-block-start:var(--beacon-custom-form-field-space-margin-block-start, var(--beacon-form-field-space-margin));margin-inline-start:0;padding-inline:var(--beacon-form-field-space-padding)}input.error{--border-size: var(--beacon-form-field-size-border-width-error);--border-color: var(--beacon-form-field-color-border-error)}input:not([type=date]).error{--font-color: var(--beacon-form-field-color-text-error)}input:not([type=date]).error:focus{--font-color: var(--beacon-form-field-color-text-default)}:host([icon-position]) input{background-image:var(--input-field-icon, none);background-position:var(--input-icon-position, none);background-repeat:no-repeat}:host([icon-position=left]){--input-icon-position: var(--beacon-form-icon-space-position-inline-start)}:host([icon-position=left]) input:not([type=date]){padding-inline-start:var(--beacon-form-icon-space-padding)}:host([icon-position=right]){--input-icon-position: var(--beacon-form-icon-space-position-inline-end)}:host([icon-position=right]) input:not([type=date]){padding-inline-end:var(--beacon-form-icon-space-padding)}\n"])));
var k = Object.defineProperty,
  I = Object.getOwnPropertyDescriptor,
  n = function n(c, t, e, l) {
    for (var r = l > 1 ? void 0 : l ? I(t, e) : t, p = c.length - 1, d; p >= 0; p--) (d = c[p]) && (r = (l ? d(t, e, r) : d(r)) || r);
    return l && r && k(t, e, r), r;
  };
var i = /*#__PURE__*/function (_$) {
  _inherits(i, _$);
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments)), _this.beaconTagName = o.beaconTagName, _this.name = "input-field", _this.iconPosition = h.NONE, _this.iconUrl = "", _this.format = "", _this.formatType = m.PATTERN;
    return _this;
  }
  _createClass(i, [{
    key: "implementFormatting",
    /**
     * Initialize IMask using the supplied format. Input fields are required to be `[type="text"]` to use IMask.
     * @link https://imask.js.org/guide.html.
     */
    value: function implementFormatting() {
      var _this2 = this;
      if (this.format) {
        this.formatStore = v(this.input, {
          mask: this.properFormat
        });
        var t = function t() {
          _this2.value = _this2.formatStore.value, _this2.internals && (_this2 == null || _this2.internals.setFormValue(_this2.value));
        };
        this.formatStore.on("accept", t);
      }
    } /** Override the FormBase handleInput method to account for possible formatting */
  }, {
    key: "handleInput",
    value: function handleInput(t) {
      var e;
      this.formatStore ? (this.value = this.formatStore.value, (e = this.internals) == null || e.setFormValue(this.value)) : this.captureEventValue(t), this.emitInput(t, {
        internals: this.internals,
        value: this.value,
        target: t == null ? void 0 : t.target
      });
    } /* eslint-disable consistent-return */
  }, {
    key: "updated",
    value: function updated(t) {
      if (!this.formatStore) return this.implementFormatting();
      if (t.has(o.formatProp) || t.has(o.formatTypeProp)) return this.formatStore.updateOptions({
        mask: this.properFormat
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t, e;
      return this.requiredProps = ["label", "id"], this.invalid = !((t = this.internals) != null && t.checkValidity()), this.validateRequiredProps(), f(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      <label for=\"", "\">", "</label>\n      ", "\n      ", "\n      <input\n        style=", "\n        class=\"", " form-anchor\"\n        title=", "\n        type=", "\n        id=", "\n        name=", "\n        .value=", "\n        aria-describedby=\"", "\"\n        aria-invalid=", "\n        aria-disabled=", "\n        pattern=", "\n        minlength=", "\n        maxlength=", "\n        ?required=", "\n        ?invalid=", "\n        @blur=", "\n        @change=", "\n        @input=", "\n        @focus=", "\n        @click=", "\n        @keydown=", "\n        @mousedown=", "\n      />\n    "])), this.id, this.label, this.hint ? f(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<p class=\"", "\" id=\"", "\">", "</p>"])), o.HINT_ID, o.HINT_ID, this.hint) : u, this.invalid ? y(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<", " message=\"", "\" id=\"", "\"></", ">"])), this.getScopedTag(o.beaconErrorTagName), (e = this.internals) == null ? void 0 : e.validationMessage, o.ERROR_ID, this.getScopedTag(o.beaconErrorTagName)) : u, this.icon, this.invalid ? o.ERROR_ID : "", a(this.title), this.formatStore ? S.TEXT : this.type, this.id, this.name, this.value, a(this.hint || this.invalid ? [this.hint ? o.HINT_ID : "", this.invalid ? o.ERROR_ID : ""].join(" ").trim() : void 0), b(this.invalidStateAsString), b(this.disabledStateAsString), a(this.pattern), a(this.minlength), a(this.maxlength), this.required, this.invalid, this.handleBlur, this.emitChange, this.handleInput, this.emitFocus, this.emitClick, this.handleKeydown, this.handleMousedown);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      var t;
      (t = this.handleDefer()) == null || t.then(function () {
        _get(_getPrototypeOf(i.prototype), "connectedCallback", _this3).call(_this3);
      });
    }
  }, {
    key: "icon",
    /**
     * Getter property for the icon URL. Requires both a URL and position to be set.
     * @returns {string} CSS variable of the icon's URL
     */
    get: function get() {
      return this.iconUrl && (this.iconPosition === h.LEFT || this.iconPosition === h.RIGHT) ? "".concat(o.iconCSSVar, ": url(").concat(this.iconUrl, ");") : "";
    }
    /**
     * Getter for the this.format depending on the formatType
     */
  }, {
    key: "properFormat",
    get: function get() {
      return this.formatType === m.REGEXP ? new RegExp(this.format) : this.format;
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(i), "styles", this), R];
    }
  }]);
  return i;
}($(N));
i.tagName = o.beaconTagName;
i.nestedComponents = o.beaconNestedComponents;
n([s({
  reflect: !0
})], i.prototype, "name", 2);
n([s({
  attribute: o.iconPositionProp
})], i.prototype, "iconPosition", 2);
n([s({
  attribute: o.iconUrlProp
})], i.prototype, "iconUrl", 2);
n([s()], i.prototype, "format", 2);
n([s({
  attribute: o.formatTypeAttr
})], i.prototype, "formatType", 2);
n([P("input")], i.prototype, "input", 2);
n([T()], i.prototype, "formatStore", 2);
export { i as BeaconInputField };